<template>
    <div v-if="success">
        <h1>Vielen Dank für Ihre Registrierung!</h1>
        <p>Ihre Daten wurden erfolgreich übermittelt. Sie bekommen in Kürze eine E-Mail um Ihre Registrierung zu bestätigen.</p>
    </div>
    <div v-else>
        <h1>Fehler</h1>
        <p class="error">Leider ist ein technischer Fehler aufgetreten und Ihre Registrierung konnte nicht abgeschlossen werden.
           Bitte gehen Sie zur vorherigen Seite zurück und übermitteln Sie Ihre Angaben erneut.</p>
        <div class="p-2">
            <Button text="Zurück zur Registrierung" @click="tryAgain"></Button>
        </div>
        <p>Besteht das Problem weiterhin, wenden Sie sich bitte an unseren Kundenservice unter bestellung@gourmetta.de</p>
    </div>
</template>

<script>
import Button from "@/views/components/ui/Button.vue";

export default {
    name: 'RegisterStep3DisplayMessage',
    components: {Button},
    props: {
        success: Boolean,
    },
    methods: {
        tryAgain() {
            this.$emit('tryAgain')
        }
    },
    emits: ['tryAgain'],
}
</script>
